import React from "react";
import lousCityBar from "../../images/lousBlack.webp";
import "./footer.css";

const Footer = () => {
  return (
    <section className="bg-[black] text-[white] py-4 mb-[-30px]">
      <img
        src={lousCityBar}
        alt=""
        className=" w-[100%] max-w-[170px] h-[100px] mx-auto"
      />
      <article className="block text-center sm:text-start sm:flex justify-center sm:justify-around items-center px-[10px] md:px-[40px]">
        <div className="h-[120px] sm:h-[130px]">
          <h1 className=" font-extrabold tracking-wider pb-2">Opening Hours</h1>
          <p>Mon-Sun</p>
          <p className="footer-time-p">3PM-7.30PM</p>
          <p className="footer-time-p">9PM-4.30AM</p>
        </div>
        <div className="h-[100px] sm:h-[130px]">
          <h1 className=" font-extrabold tracking-wider pb-2">Contract Us</h1>
          <p>+8613238673203</p>
          <p>shawnniamul58@gmail.com</p>
        </div>
        <div className="h-[130px]">
          <h1 className=" font-extrabold tracking-wider pb-2">Follow Us</h1>
          <div className=" flex flex-col underline">
            <a href="https://www.facebook.com/niamul102" target="_blank" className=" hover:text-[#8b8bff]">Facebook</a>
            <a href="https://www.linkedin.com/in/niamul102/" target="_blank" className=" hover:text-[#8b8bff]">Linkedin</a>
            <a href="https://github.com/Shawn102" target="_blank" className=" hover:text-[#8b8bff]">Github</a>
          </div>
        </div>
      </article>
      <p className="text-center text-[#f56161] font-extrabold text-[10px] sm:text-[15px] tracking-wider copyright">Copyright <span className="footer-copy-symbol">&#169;</span> 2022-{new Date().getFullYear()} MD NIAMUL HAKIM</p>
    </section>
  );
};

export default Footer;
